<template>
    <div id="container">
        <div class="search_box" v-loading="loading">
            <h2>中国雅江清洁能源有限公司</h2>
            <div class="search_box_item">
                <div class="search_box_item_input">
                    <input type="text" class="s_ipt" name="wd" id="kw" maxlength="100" autocomplete="off" />
                    <span class="soutu" @click="soundRecorder"></span>

                    <input @click="searchclick" type="submit" :value="!gogo?'点击检索':'取消回答'" id="su" :style="'background-color:'+(!gogo?'blue':'red')" class="btn self-btn bg s_btn" />
                </div>
            </div>
        </div>
        <div class="equ_list">
            <div class="equ_header">
                <div>
                    猜你想问<span>&gt;</span>
                </div>
                <div class="equ_change" @click='getList'>
                    <i class="el-icon-refresh"></i>
                    换一批
                </div>
            </div>
            <div style="margin-top: 20px"></div>
            <div class="a_href" v-for="(item, index) in qili" :key="index" @click="se(item)" :title="item">

                <span class="a_href_number">{{ index + 1 }}</span>{{ item }}

            </div>
        </div>
        <div v-for="(item, index) in bookTableList" :key="index" class="item">
            <div style="display: flex">
                <a style="
            color: #000e28;
            font-weight: 400;
            font-size: 16px;
            margin-left: 20px;
            text-decoration: none;
            margin-top: 20px;
          ">{{ item.ask }}？<img src="../../../static/img/shengyin.png" height="16" width="16" @click="playVoice" />
                    <img src="../../../static/img/zanting.png" height="16" width="16" @click="handlePause"
                        v-if="playerStatus" style="margin-left: 10px; margin-right: 10px" />
                    <img src="../../../static/img/kaishi.png" height="16" width="16" @click="handleResume" v-else /></a>
            </div>

            <div style="text-align: justify;">
                <span style="
            margin-top: 20px;
            font-weight: 400;
            font-size: 15px;
            line-height: 18px;
            white-space: pre-wrap;
          ">结果：{{ item.re }}</span>
            </div>
            <div style="display: flex">
                <!-- <a
          style="position: absolute; right: 20px; font-size: 12px; color: red"
          >分享结果</a
        > -->
            </div>
            <div style="height: 20px"></div>
        </div>
    </div>
</template>

<script>
import userapi from "@/api/user";
import Recorder from "js-audio-recorder";
import axios from "axios";

const synth = window.speechSynthesis; // 启用文本
const msg = new SpeechSynthesisUtterance();
export default {
    props: {},
    data() {
        return {
            currentPage: 1,
            input: "",
            widthWiner: false,
            bookTableList: [],
            qili: [
                "待开发的荒滩地大约是多少",
                "什么导致了自然资源与脆弱的生态环境遭到破坏而失衡",
                "雅鲁藏布大峡谷地质成因的作者",
                "杨逸畴发表了哪些",
            ],
            recorderStatus: false,
            recorder: new Recorder({
                sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
                sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值
                numChannels: 1, // 声道，支持 1 或 2， 默认是1
                // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
            }),
            loading: false,
            speakStatus: false,
            gogo:false,
            playerStatus: true,
            speech: null,
            wsSocket:null,
            readMsg:
                "受到许多因素的影响，如地形、气候和地质条件等。因此，对于雅鲁藏布江流量的精确测量，需要考虑到这些因素的复杂性，并采用各种测量方法和技术。",
        };
    },
    watch: {
        isShow: {
            handler(nv, ov) {
                if (nv) {
                    this.getPermission();
                }
            },
        },
    },
    methods: {
        handleResume(e) {
            this.playerStatus = true;
            synth.resume(msg);
        },
        handlePause(e) {
            this.playerStatus = false;
            synth.pause(msg);
        },
        playVoice() {
            //console.log(111)
            //console.log(this.readMsg)
            this.speakStatus = !this.speakStatus;
            if (this.speakStatus) {
                this.handleSpeak(this.readMsg); // 传入需要播放的文字
            } else {
                this.handleStop(this.readMsg);
            }
        },
        // 语音播报的函数
        handleSpeak(text) {
            msg.text = text; // 文字内容: 测试内容
            msg.lang = "zh-CN"; // 使用的语言:中文
            msg.volume = 1; // 声音音量：1
            msg.rate = 1; // 语速：1
            msg.pitch = 1; // 音高：1
            //console.log("synth",synth)
            //console.log("msg",msg)
            synth.speak(msg); // 播放
        },
        // 语音停止
        handleStop(e) {
            msg.text = e;
            msg.lang = "zh-CN";
            synth.cancel(msg); // 取消该次语音播放
        },
        resoleRecorderText(data) {
            this.loading = true;
            userapi.resoleRecorder(data).then((res) => {
                if (res.data != null) {
                    // if ( document.getElementById( "kw" ) ) {
                    document.getElementById("kw").value = res.data;
                    // } else {
                    // this.input = res.data
                    // }
                }
                this.loading = false;
            });
        },
        //录音
        soundRecorder() {
            this.recorderStatus = !this.recorderStatus;
            //获取麦克风权限
            Recorder.getPermission().then(
                () => {
                    if (this.recorderStatus) {
                        //开始录音
                        this.$message.success("开始录音");
                        this.recorder.start().then(
                            () => { },
                            (error) => {
                                this.$message({
                                    message: "请先允许该网页使用麦克风",
                                    type: "info",
                                });
                                console.log(`${error.name} : ${error.message}`);
                            }
                        );
                    } else {
                        //停止录音
                        this.recorder.stop();
                        this.$message.success("停止录音");
                        var PCMBlob = this.recorder.getPCMBlob();
                        //this.recorder.downloadPCM('pcm');//这里传参进去的时文件名
                        //console.log("data: ", PCMBlob);

                        let formData = new FormData();
                        //此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
                        var blob = new Blob([PCMBlob]);
                        formData.append("file", blob);
                        this.resoleRecorderText(formData);
                    }
                },
                (error) => {
                    console.log(`${error.name} : ${error.message}`);
                }
            );
        },
        async searchclick() {
            if(this.gogo){
                this.wsSocket.close();
                this.gogo = !this.gogo;
                return
            }
            var that =this
            var search = document.getElementById("kw").value;
            // this.$router.push("/tupu?searchinfo="+search);
            //       this.$router.push(`/de?keyword=`+`&person=` +`&book=`
            // +`&year=`+`&gjz=`+search +`&company=` +`&literature=` );
            if (!search) {
                return this.$message({
                    message: "请输入搜索内容",
                    type: "warning"
                })
            }
this.gogo = !this.gogo;
        let askParam = {
            memory_name: "XkUPQjLfJ3Dx7I0fPfkNA",
            prompt: search,
            step: 3
        }
        let againAskQuestion = "";
        await  axios.post("https://edam.tscon.cn:7778/wenda66api/api/find_rtst_in_memory",askParam).then((res) => {
            if (res.data != null && res.data != '') {
                againAskQuestion += "system: 请扮演一名专业分析师，根据以下内容用中文回答问题：" + search + "\n不要回答与问题无关的内容。可以参考一下内容：";
                res.data.forEach((item) => {
                    againAskQuestion += item.content;
                })
            }else{
                againAskQuestion += search;
            }

        })
                    that.bookTableList.unshift({
                        ask: search,
                        re: "",
                    });
            new Promise((resolve) => {
        let result = ''
        const wsSocket = new WebSocket('wss://mcc.wedam.com.cn/wendareportxz/ws');
        this.wsSocket = wsSocket;
        wsSocket.onmessage = function (event) {
            result = event.data
            that.bookTableList[0].re = result.replace(/[\r\n]+!$/g, "<br>")
            that.gogo= true
            // callback(result)
        };
        wsSocket.onopen = function () {
            if (wsSocket.readyState === 1) {
                wsSocket.send(JSON.stringify({
                    prompt: againAskQuestion,
                    keyword: againAskQuestion,
                    temperature: 1.3,
                    top_p: 0.5,
                    max_length: 4096,
                    history: []
              }))
            }
        };
        wsSocket.onclose = function (event) {
            console.log('回答完毕', event.code, result)
            that.gogo = false
            wsSocket.close();
        }
        wsSocket.onerror = function (error) {
            console.log("发生错误", error)
        }
        resolve(wsSocket)
    })
            // userapi
            //     .getRequest("/search/questionanswer", {
            //         keyword: search,
            //     })
            //     .then((res) => {
            //         var re = res.data.data;
            //         //console.log("res.data.data", res.data.data);
            //         this.readMsg = res.data.data;
            //         this.bookTableList.unshift({
            //             ask: search,
            //             re: re,
            //         });
            //     });
        },
        se(search) {
            document.getElementById("kw").value = search;
            // userapi
            //     .getRequest("/search/questionanswer", {
            //         keyword: search,
            //     })
            //     .then((res) => {
            //         var re = res.data.data;
            //         this.readMsg = res.data.data;
            //         //console.log(this.readMsg)
            //         this.bookTableList.unshift({
            //             ask: search,
            //             re: re,
            //         });
            //     });
            this.searchclick();
        },
        getList() {
            if (this.currentPage >= 5) {
                this.currentPage = 1
            }
            userapi
                .getRequest("/api/getRackSerach", {
                    type: 0,
                    count: this.currentPage * 15,
                })
                .then((res) => {
                    var re = [];
                    for (var a = 0; a < res.data.length; a++) {
                        re.push(res.data[a].c_info);
                    }
                    // this.dataList = re
                    this.qili = re.slice((this.currentPage - 1) * 15, this.currentPage * 15)
                    this.currentPage++
                });
        }
    },
    created() { },
    destroyed() {
        //console.log("离开页面");
        this.handleStop(this.readMsg);
    },
    mounted() {
        //console.log("window.innerWidth", window.innerWidth);
        if (window.innerWidth > 1100) {
            this.widthWiner = false;
        } else {
            this.widthWiner = true;
        }
        // window.getElementById
        // 创建录音实例
        this.recorder = new Recorder({
            sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
            sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值
            numChannels: 1, // 声道，支持 1 或 2， 默认是1
            // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
        });
        // this.speechInit();
        this.getList()
    },
};
</script>
<style scoped  >
/* 中间搜索部分 */
.search_box_item {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin: 0 0 20px 0;
}

.search_box_item .search_box_item_input {
    position: relative;
    width: 512px;
    margin: 0 auto;
    display: inherit;
}

.soutu {
    background: url('../../../static/img/yuyin.png') no-repeat;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    /* right: 750px; */
    top: 0;
    right: 90px;
    margin-top: 10px;
    width: 26px;
    height: 24px;
}

#kw {
    width: 512px;
    height: 16px;
    padding: 12px 16px;
    padding-right: 40px;;
    font-size: 16px;
    margin: 0;
    vertical-align: top;
    outline: 0;
    box-shadow: none;
    border-radius: 10px 0 0 10px;
    border: 2px solid #c4c7ce;
    background: #fff;
    color: #222;
    overflow: hidden;
    box-sizing: content-box;
    -webkit-tap-highlight-color: transparent;
    text-overflow: ellipsis;
}

#su {
    cursor: pointer;
    width: 100px;
    height: 44px;
    line-height: 45px;
    line-height: 44px;
    padding: 0;
    background: 0 0;
    background-color: #4e6ef2;
    border-radius: 0 10px 10px 0;
    font-size: 17px;
    color: #fff;
    box-shadow: none;
    font-weight: 400;
    border: none;
    outline: 0;
    margin-left: 10px;
}

.search_input {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* >>>.el-input__inner {
    height: 46px !important;
} */

.when {
    height: 16px;
    line-height: 16px;
    font-size: 20px;
}

.tip {
    margin-top: 50px;
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 10px;
}

.item {
    width: 532px;
    /* margin-left: 33%; */
    background: #f8fafd;
    margin-top: 30px;
    border: 1px solid #e0ebf7;
    position: relative;
    margin: 0 auto;
}

/* .phone {
    .item {
        width: 532px;

        background: #f8fafd;
        margin-top: 30px;
        border: 1px solid #e0ebf7;

    }
} */
.phone_item {
    width: 98%;
    border-radius: 10px;
    background: #f8fafd;
    margin-top: 10px;
    border: 1px solid #e0ebf7;
}

.a_href {

    font: 14px/22px Arial, sans-serif;
    width: 260px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
    /* margin-top: 10px; */
    -webkit-line-clamp: 1;
    word-wrap: break-word;
    word-break: normal;
    cursor: pointer;
    text-align: left;
    margin: 5px 0;
    display: block;
    color: #2440b3;

    div {
        width: 260px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        /* vertical-align: middle; */
    }
}

.a_href_number {
    display: inline-block;
    width: 20px;
    color: #9195A3;
    font-size: 16px;
}

.search_box {
    margin-top: 50px;
    width: 100%;
    text-align: center;
}

/* 猜你想问 */
.equ_list {
    position: absolute;
    right: 10px;
    width: 400px;
    text-align: left;
}

.equ_header {
    height: 16px;
    line-height: 16px;
    font-size: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
}

.equ_change {
    font-size: 16px;
    cursor: pointer;
    margin-right: 45px;
}

.equ_change:hover {
    color: #2440b3;
}

.equ_change .el-icon-refresh:hover {
    color: #2440b3;
}

.equ_change /deep/ .el-icon-refresh:target {
    /* transform: rotate(-180deg)!important; */
    animation: tra 1s;
}

@keyframes tra {
    0% {
        transform: rotate(0deg);
    }

    1000% {
        transform: rotate(-180deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/main.vue